/**
 * Accounts Receivable shared types
 */

/**
 * Source of a sales order - where it originated from
 */
export enum SalesOrderSource {
  Edi = "edi",
  Email = "email",
  DirectEntry = "direct_entry",
  FileUpload = "file_upload",
}

/**
 * Status of a staged sales order (draft/review state)
 * These are orders that have been received but not yet approved
 */
export enum StagedPurchaseOrderStatus {
  RECEIVED = "RECEIVED",
  // PENDING_REVIEW = "PENDING_REVIEW",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  /** Human needs to review/approve a suggested email draft */
  NEEDS_ATTENTION = "NEEDS_ATTENTION",
  /** Draft approved and sent, awaiting customer response */
  WAITING_ON_CUSTOMER = "WAITING_ON_CUSTOMER",
}
